// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.broucherfirstpage-container {
  display: flex;
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding: 0px;
  position: relative;
  box-sizing: border-box;
  min-height: calc(100vh - nav-height);
}

.broucherfirstpage-image-section {
  width: 60%;
  position: relative;
  clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
}

.broucherfirstpage-about-image {
  width: 100%;
  height: 130%;
  object-fit: cover;
}

.broucherfirstpage-text-section {
  width: 85%;
  background-color: #2faac6;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  clip-path: polygon(10% 0, 100% 0, 100% 100%, 0% 100%);
  margin-left: -6%;
}

.broucherfirstpage-container::before {
  content: "";
  position: absolute;
  z-index: 2;
  background: linear-gradient(
    to bottom right,
    rgb(16, 176, 216),
    rgba(214, 215, 219, 0)
  );
  pointer-events: none;
  left: 40%;
  width: 3%;
  height: 150%;
  top: -25%;
  transform: skewX(-10deg) translate(-5px, 10px);
}

.broucherfirstpage-text-section h1 {
  font-size: 3em;
  margin-bottom: 10px;
  z-index: 3;
  font-family: Arial, Helvetica, sans-serif;
}

.broucherfirstpage-text-section p {
  font-size: 1.5em;
  text-align: center;
  padding: 0 20px;
  z-index: 3;
}

.container {
  display: flex;
  flex-direction: row;
  padding: 20px;
  gap: 20px;
}

.image-wrapper {
  flex: 1 1;
}

.image {
  width: 100%;
  max-width: 400px;
  border-radius: 8px;
}

.text-wrapper {
  flex: 2 1;
  padding: 10px;
}

.info-section {
  margin: 20px 0;
}

@media (max-width: 768px) {
  .broucherfirstpage-container {
    flex-direction: column;
    height: auto;
  }

  .broucherfirstpage-image-section {
    width: 100%;
    height: 55vh;
    clip-path: none;
  }

  .broucherfirstpage-text-section {
    width: 100%;
    height: 35vh;
    margin-left: 0;
    clip-path: none;
    padding: 20px;
  }

  .broucherfirstpage-text-section h1 {
    font-size: 2em;
    margin-right: 30px;
  }

  .broucherfirstpage-text-section p {
    font-size: 1em;
    margin-right: 15px;
  }

  .broucherfirstpage-container::before {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Broucherfirst/Broucherfirst.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;EACrD,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV;;;;GAIC;EACD,oBAAoB;EACpB,SAAS;EACT,SAAS;EACT,YAAY;EACZ,SAAS;EACT,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".broucherfirstpage-container {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  padding: 0px;\n  position: relative;\n  box-sizing: border-box;\n  min-height: calc(100vh - nav-height);\n}\n\n.broucherfirstpage-image-section {\n  width: 60%;\n  position: relative;\n  clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);\n}\n\n.broucherfirstpage-about-image {\n  width: 100%;\n  height: 130%;\n  object-fit: cover;\n}\n\n.broucherfirstpage-text-section {\n  width: 85%;\n  background-color: #2faac6;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  clip-path: polygon(10% 0, 100% 0, 100% 100%, 0% 100%);\n  margin-left: -6%;\n}\n\n.broucherfirstpage-container::before {\n  content: \"\";\n  position: absolute;\n  z-index: 2;\n  background: linear-gradient(\n    to bottom right,\n    rgb(16, 176, 216),\n    rgba(214, 215, 219, 0)\n  );\n  pointer-events: none;\n  left: 40%;\n  width: 3%;\n  height: 150%;\n  top: -25%;\n  transform: skewX(-10deg) translate(-5px, 10px);\n}\n\n.broucherfirstpage-text-section h1 {\n  font-size: 3em;\n  margin-bottom: 10px;\n  z-index: 3;\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n.broucherfirstpage-text-section p {\n  font-size: 1.5em;\n  text-align: center;\n  padding: 0 20px;\n  z-index: 3;\n}\n\n.container {\n  display: flex;\n  flex-direction: row;\n  padding: 20px;\n  gap: 20px;\n}\n\n.image-wrapper {\n  flex: 1;\n}\n\n.image {\n  width: 100%;\n  max-width: 400px;\n  border-radius: 8px;\n}\n\n.text-wrapper {\n  flex: 2;\n  padding: 10px;\n}\n\n.info-section {\n  margin: 20px 0;\n}\n\n@media (max-width: 768px) {\n  .broucherfirstpage-container {\n    flex-direction: column;\n    height: auto;\n  }\n\n  .broucherfirstpage-image-section {\n    width: 100%;\n    height: 55vh;\n    clip-path: none;\n  }\n\n  .broucherfirstpage-text-section {\n    width: 100%;\n    height: 35vh;\n    margin-left: 0;\n    clip-path: none;\n    padding: 20px;\n  }\n\n  .broucherfirstpage-text-section h1 {\n    font-size: 2em;\n    margin-right: 30px;\n  }\n\n  .broucherfirstpage-text-section p {\n    font-size: 1em;\n    margin-right: 15px;\n  }\n\n  .broucherfirstpage-container::before {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
